import { useTranslation } from "react-i18next";
import ProfileDropdown from "../../../../components/ProfileDropdown";
import { useAppSelector } from "../../../../store/hooks";
import { useOrderingLogout } from "../../components/useOrderingLogout";

/**
 * Горната лента на „Обедно меню" (десктоп) — като на справките: заглавие
 * вляво, профилът вдясно (Backoffice, цял екран, изход). „Ново" е в лявата колона.
 */
export const LunchMenusTopBar = () => {
  const { t } = useTranslation();
  const names = useAppSelector((s) => s.auth.names);
  const username = useAppSelector((s) => s.auth.username);
  const access = useAppSelector((s) => s.auth.access);
  const { handleLogout, logoutModal } = useOrderingLogout();

  return (
    <header className="flex min-h-[60px] shrink-0 items-center justify-between gap-2.5 border-b border-pos-line bg-pos-card px-7 py-[11px]">
      <h1 className="m-0 truncate text-[22px] font-bold leading-[1.2] tracking-[-0.5px] text-pos-ink">
        {t("lunchMenu.title")}
      </h1>
      <div className="flex shrink-0 items-center gap-2.5">
        <ProfileDropdown
          displayName={names || username || ""}
          username={username ?? ""}
          access={access}
          isNarrow={false}
          onLogout={handleLogout}
        />
      </div>
      {logoutModal}
    </header>
  );
};
